<div class="desktop-width-limiter page-padding task-page">
  @if (loading) {
    <div class="loading">
      <mat-progress-spinner
        class="loading-spinner"
        [diameter]="250"
        mode="indeterminate"
        color="primary"
        >
      </mat-progress-spinner>
      <div class="loading-text"><h1>Laden...</h1></div>
    </div>
  }
  @if (!loading && error) {
    <div class="error">
      <h1>- {{ 'sebbie_ranking.error_loading_tasks' | translate }} -</h1>
    </div>
  }
  @if (!loading && !error) {
    <div>
      <header-content-task
        [profile]="profile"
        [promotionAction]="currentPromotionAction"
        [availableTaskIds]="availableTasksIds"
        [spotsReceived]="spotsReceived"
        [isCurrentPromotion]="true"
      />
      @if (availableTasks.length > 0) {
        <div class="row overview-items">
          @for (task of availableTasks; track task; let i = $index) {
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxxl-2 overview-item "
              >
              <task-card
                [task]="task"
                [numberInList]="i + 1"
                [completedCount]="numberOfTimesTaskCompleted(task.id)"
                />
              </div>
            }
          </div>
        }
        @if (availableTasks.length === 0) {
          <div class="no-tasks">
            <h1>- {{'sebbie_ranking.no_tasks_promotion' | translate}} -</h1>
          </div>
        }
        <promotion-history />
    </div>
  }
</div>